const ORGANIZATION_USER_LIST_CACHE_ID = 'OrganizationUserList';

const ORGANIZATION_USER_LIST_EVENT = {
  UPDATE: 'UpdateOrganizationUserList',
  UPDATE_COUNT: 'UpdateCountOrganizationUserList',
};

export {ORGANIZATION_USER_LIST_CACHE_ID, ORGANIZATION_USER_LIST_EVENT};
